import React from 'react';
import '../styles/Address.css';
import {
  FaPhone,
  FaEnvelope,
  FaGlobe,
  FaMapMarkerAlt,
  FaFacebookF,
  FaLinkedinIn,
  FaYoutube
} from 'react-icons/fa';

import buildingImage from '../Assets/Images/akij-house-3.jpg';
import mapImage from '../Assets/Images/akij-map.jpg';

function Address() {
  return (
    <div className="contact-container">
      <div
        className="contact-left"
        style={{ backgroundImage: `url(${buildingImage})` }}
      >
        <div className="contact-card">
          <p><FaMapMarkerAlt /> Akij House, 198 Bir Uttam Mir Shawkat Sarak,<br />Tejgaon, Dhaka 1208</p>
          <p><FaPhone /> Cell: <span className="highlight">+880 1730-353735</span></p>
          <p><FaPhone /> Office: <span className="highlight">+880 9666700900</span></p>
          <p><FaEnvelope /> Email: <a href="mailto:info@akijinsaf.com">info@akijinsaf.com</a></p>
          <p><FaGlobe /> Web: <a href="https://www.akij.net">www.akij.net</a></p>
          <div className="social-icons">
            <FaFacebookF />
            <FaLinkedinIn />
            <FaYoutube />
          </div>
        </div>
      </div>

      <div className="contact-right">
        <img src={mapImage} alt="Map Location" className="static-map-image" />
      </div>
    </div>
  );
}

export default Address;
